import { CONFIGURATION_APIS } from "@/api_framework/api_config";
import { IPreferredStaffBody } from "@/api_framework/api_modals/Configuration";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import axios, { AxiosError } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";

AxiosCurlirize(axios, () => {});

// Create (POST) or update (PUT) a single clinic preferred-doctor mapping.
// Same endpoint, method decides intent — mirrors the backend CRUD view.
export const usePreferredStaffSaveAPI = () => {
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (body: IPreferredStaffBody, mode: "create" | "update") => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const url = CONFIGURATION_APIS.PREFERRED_STAFF_LIST.baseURL;
        const options = {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        };
        const response =
          mode === "create" ? await axios.post(url, body, options) : await axios.put(url, body, options);
        toast.success(mode === "create" ? "Preferred doctor added" : "Preferred doctor updated");
        return response.data;
      } catch (error) {
        if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError;
          captureError(axiosError);
          if (axiosError.config) {
            sendCurl(axiosError.config["curlCommand"]);
          }
          const message = (axiosError.response?.data as { message?: string })?.message;
          if (message) toast.error(message);
        }
        throw error;
      }
    },
    [configuration, captureError, sendCurl],
  );

  return { execute };
};
